import React from "react"
import styles from "./StripeAccountCard.module.css"
import { MailOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { CircledIcon } from "ui/CircledIcon"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { isStripeConnectedSelector } from "store/user"
import { Flex } from "antd"
import { spacings } from "themes/variables"
import { Text } from "ui/Typography"

export const StripeDetails = ({ stripeEmail, isStripeChargeEnabled, errorStripeMessage, stripeLink }) => {
  const { t } = useTranslation()
  const isStripeConnected = useSelector(isStripeConnectedSelector)

  const showUnderReview = isStripeConnected && !isStripeChargeEnabled && !errorStripeMessage
  return (
    <div className={styles.stripeInfo}>
      {stripeEmail && (
        <Flex gap={spacings.XS} align="start" className={styles.emailRow}>
          <MailOutlined className={styles.emailIcon} />
          <Text className={styles.emailText}>{stripeEmail}</Text>
        </Flex>
      )}

      {errorStripeMessage && (
        <p>
          <strong className={styles.errorMessage}>{errorStripeMessage}</strong>
        </p>
      )}

      {showUnderReview && (
        <p>
          <strong className={styles.errorMessage}>{t("pro.settings.stripe.account_under_review")}</strong>
        </p>
      )}

      {stripeLink && (
        <div>
          <a href={stripeLink} target="_blank" rel="noopener noreferrer">
            Login to Stripe
          </a>
        </div>
      )}
      <div className={styles.chargeStatus}>
        {isStripeChargeEnabled !== undefined && (
          <CircledIcon name={isStripeChargeEnabled ? "Check" : "AlertCircle"} colorType={isStripeChargeEnabled ? "success" : "error"} />
        )}
      </div>
    </div>
  )
}

StripeDetails.propTypes = {
  stripeEmail: PropTypes.string,
  isStripeChargeEnabled: PropTypes.bool,
  errorStripeMessage: PropTypes.string,
  stripeLink: PropTypes.string
}
